<p>
  <button
    app-add-button
    [label]="'events.settings.registration-fields.ceu-edit.add-ceu-label' | translate"
    (click)="handleAddClick()"
  ></button>
</p>

<table class="wl-credit-types-grid" [hidden]="!availValueCreditTypes?.length">
  <thead>
    <tr>
      <th></th>
      <th>
        {{ 'events.settings.registration-fields.ceu-edit.credit-type-column-header' | translate | titlecase }}
      </th>
      <th>
        {{ 'events.settings.registration-fields.ceu-edit.ceu-credits-column-header' | translate | titlecase }}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr
      *ngFor="let availValueCreditType of availValueCreditTypes"
      [ngClass]="{ 'wl-pending-delete': availValueCreditType.ObjectState == _objectStateEnum.Deleted }"
    >
      <td>
        <button
          pButton
          type="button"
          class="atlas-btn atlas-btn-danger btn-xs"
          icon="pi pi-trash"
          (click)="handleRemoveClick(availValueCreditType)"
          [hidden]="availValueCreditType.ObjectState == _objectStateEnum.Deleted"
        ></button>

        <button
          pButton
          type="button"
          class="atlas-btn atlas-btn-default btn-xs"
          icon="pi pi-refresh"
          (click)="handleUnRemoveClick(availValueCreditType)"
          [hidden]="availValueCreditType.ObjectState != _objectStateEnum.Deleted"
          [pTooltip]="'common.undelete' | translate | titlecase"
          tooltipPosition="top"
        ></button>
      </td>
      <td>
        <wl-events-ceu-type-dropdown
          [(ngModel)]="availValueCreditType.CeCreditTypeId"
          inputCssClass="form-control wl-credit-type-input"
          [required]="true"
          [disabled]="availValueCreditType.ObjectState == _objectStateEnum.Deleted"
        ></wl-events-ceu-type-dropdown>
      </td>
      <td>
        <input
          [(ngModel)]="availValueCreditType.Credits"
          class="form-control wl-credits-input"
          type="number"
          min="0"
          [disabled]="availValueCreditType.ObjectState == _objectStateEnum.Deleted"
        />
      </td>
    </tr>
  </tbody>
</table>
